import React from "react";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { Formik } from 'formik';
export default function AddKeywordModal({ isOpen, closeModal, keywords, crt_created_image_id, addNewKeyword, deleteKeyword }) {

  const formSubmit = async (values, { resetForm })=>{
 
    const data = {
      created_image_id:crt_created_image_id,
      keyword:values.keyword
    }
    resetForm();
    addNewKeyword(data)
  }

  return (
    <div>

      <Dialog fullWidth open={isOpen} onClose={closeModal} aria-labelledby="form-dialog-title" maxWidth={`xs`} >
        <DialogTitle id="form-dialog-title" className="modal-title">Add New Keyword</DialogTitle>
        <Formik
          initialValues={{ keyword: '' }}
          validate={values => {
            const errors = {};
            if (!values.keyword) {
              errors.keyword = 'Keyword is required';
            }
            return errors;
          }}
          onSubmit={formSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
     
            /* and other goodies */
          }) => (<form onSubmit={handleSubmit}>
            <DialogContent >
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Add Keyword"
                type="text"
                fullWidth
                name="keyword"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.keyword}
              />
                {errors.keyword && touched.keyword && errors.keyword}
              <div className="keywords-list">
                <ul>
                  {
                    keywords.length !== 0 && keywords.map((item, i) => {
                      return <li key={i} className="keyword-item">
                        <div>
                        {item.keywords}
                        </div>
                        <div>
                        <Button type="button" color="secondary" variant="contained" onClick={()=>deleteKeyword(item.id)}>
                          <DeleteOutlineIcon fontSize="small"/>
                        </Button>
                        </div>
                       
                      </li>
                    })
                  }

                </ul>
              </div>
            </DialogContent>
            <DialogActions>
              <Button type="button" onClick={closeModal} variant="contained" color="secondary">
                Close
              </Button>
              <Button type="submit" color="primary" variant="contained">
                Submit
              </Button>
            </DialogActions>
          </form>)}
        </Formik>
      </Dialog>
    </div>
  );
}